export const baseUrl = 'https://test.com';
export const marketingUrl = 'https://google.com';
export const webName = 'VRScheduler';
export const defaultLanguage = 'en';
export const supportedLanguages = { // GR1 -- Do not remove
     en: 'English', fr: 'French' }